import { ConfigurationSourceDataMap, CoordinatingGroup, Institution, MasterGroup, Metadata, Participant, SourceData, Trial } from "@/api/dtos";
import { useMemo } from "react";
import { createEvent } from "./useEvent";

export const createEvents = (
    metadata?: Metadata, 
    trialConfiguration?: ConfigurationSourceDataMap, 
    configuration?: ConfigurationSourceDataMap, 
    sourceData?: SourceData,
    trial?: Trial, 
    masterGroup?: MasterGroup,
    coordinatingGroup?: CoordinatingGroup,
    institution?: Institution,
    participant?: Participant,
    preview?: boolean
) => {
    if (!metadata || !metadata.events) {
        return undefined;
    }

    return Object.keys(metadata.events).reduce<ReturnType<typeof createEvent>[]>((events, studyEventOid) => {
        const sourceDataEvents = sourceData?.events?.[studyEventOid];

        const sourceDataEventRepeats = Object.keys(sourceDataEvents ?? {});

        if (!sourceDataEventRepeats || sourceDataEventRepeats.length === 0) {
            events.push(createEvent(
                metadata, 
                trialConfiguration?.events, 
                configuration?.events,
                sourceData?.events,
                trial,
                masterGroup, 
                coordinatingGroup,
                institution,
                participant,
                configuration?.configuration?.isGlobal,
                configuration?.configuration?.id, 
                studyEventOid,
                1,
                preview
            ))
        }
        else {
            for (let studyEventRepeat of sourceDataEventRepeats) {
                events.push(createEvent(
                    metadata, 
                    trialConfiguration?.events, 
                    configuration?.events,
                    sourceData?.events,
                    trial,
                    masterGroup, 
                    coordinatingGroup,
                    institution,
                    participant,
                    configuration?.configuration?.isGlobal,
                    configuration?.configuration?.id, 
                    studyEventOid,
                    +studyEventRepeat,
                    preview
                ));
            }
        }

        return events;
    }, [])
    .filter(x => !!x)
    .sort((a, b) => {
        if (a?.eventMetadata?.order! === b?.eventMetadata?.order!)
        {
            return a?.studyEventRepeat! < b?.studyEventRepeat! ? -1 : 1;
        }
            
        return a?.eventMetadata?.order! < b?.eventMetadata?.order! ? -1 : 1;
    });
}

const useEvents = (
    metadata?: Metadata, 
    trialConfiguration?: ConfigurationSourceDataMap, 
    configuration?: ConfigurationSourceDataMap, 
    sourceData?: SourceData,
    trial?: Trial, 
    masterGroup?: MasterGroup,
    coordinatingGroup?: CoordinatingGroup,
    institution?: Institution,
    participant?: Participant,
    preview?: boolean
) => {
    return useMemo(() => {
        return createEvents(
            metadata, 
            trialConfiguration, 
            configuration, 
            sourceData, 
            trial, 
            masterGroup, 
            coordinatingGroup, 
            institution,
            participant, 
            preview
        )
    }, [
        metadata, 
        trialConfiguration?.events, 
        configuration?.events, 
        sourceData?.events, 
        trial, 
        institution,
        masterGroup, 
        coordinatingGroup, 
        participant, 
        preview
    ]) as Array<NonNullable<ReturnType<typeof createEvent>>> | undefined
};

export default useEvents;